module.exports = __webpack_public_path__ + "assets/img/00080.9c975b30.png";